<script>
export default {
  data() {
    return {
      myPageItems: [
        {
          key: 'amount',
          name: '',
          isEnable: 1,
          items: [
            {
              key: 'wallet',
              name: '充值',
              isEnable: 1
            },
            {
              key: 'withdrawal',
              name: '提现',
              isEnable: 1
            },
            {
              key: 'transfer',
              name: '额度转换',
              isEnable: 1
            },
            {
              key: 'yeb',
              name: '余额宝',
              isEnable: 1
            },
            {
              key: 'transfertomember',
              name: '转账',
              isEnable: 1
            },
            {
              key: 'balanceIncome',
              name: '余额生金',
              isEnable: 1
            }
          ]
        },
        {
          key: 'record',
          name: '我的记录',
          isEnable: 1,
          items: [
            {
              key: 'bettingplatform',
              name: '投注记录',
              isEnable: 1
            },
            {
              key: 'rechargeWithdrawalRecord',
              name: '充提记录',
              isEnable: 1
            },
            {
              key: 'billChangeRecord',
              name: '账变记录',
              isEnable: 1
            },
            {
              key: 'personalReport',
              name: '个人报表',
              isEnable: 1
            },
            {
              key: 'checkRegister',
              name: '签到',
              isEnable: 0
            },
            {
              key: 'redbag',
              name: '红包',
              isEnable: 0
            },
            {
              key: 'integralExchange',
              name: '积分兑换',
              isEnable: 1
            },
            {
              key: 'activity',
              name: '活动办理',
              isEnable: 1
            },
            {
              key: 'memberActivity',
              name: '活动大厅',
              isEnable: 1
            }
          ]
        },
        {
          key: 'proxy',
          name: '代理管理',
          isEnable: 1,
          items: [
            {
              key: 'userManage',
              name: '用户管理',
              isEnable: 1
            },
            {
              key: 'openingAccountCenter',
              name: '开户中心',
              isEnable: 1
            },
            {
              key: 'proxyCommission',
              name: '代理佣金',
              isEnable: 1
            },
            {
              key: 'teamReport',
              name: '团队报表',
              isEnable: 1
            }
          ]
        },
        {
          key: 'manage',
          name: '管理中心',
          isEnable: 1,
          items: [
            {
              key: 'safeCenter',
              name: '安全中心',
              isEnable: 1
            },
            {
              key: 'preferential',
              name: '优惠活动',
              isEnable: 1
            },
            {
              key: 'kefu',
              name: '在线客服',
              isEnable: 1
            },
            {
              key: 'messageCenter',
              name: '消息中心',
              isEnable: 1
            }
          ]
        },
        {
          key: 'finance',
          name: '财务便捷',
          isEnable: 1,
          items: [
            {
              key: 'walletCourse',
              name: '如何充值',
              isEnable: 1
            },
            {
              key: 'withdrawalCourse',
              name: '如何提款',
              isEnable: 1
            },
            {
              key: 'transferCourse',
              name: '如何转账',
              isEnable: 1
            }
          ]
        }
      ]
    }
  },
  computed: {
    showCommission() {
      let flag = 1
      try {
        flag = this._config.app_config.configValue.showCommission
        flag = flag == undefined ? 1 : flag
      } catch (e) { }
      return flag
    },
    //是否显示活动大厅
    isShowActivityRoom() {
      let flag = 0
      try {
        flag = this._config.memberactivity_config.configValue.isShow
        flag = flag === undefined ? 0 : flag
      } catch (e) {
        flag = 0
      }

      return flag
    },
    isShowMyPageCheckRegister() {
      let type = 1
      if (this._config.app_config.configValue.hasOwnProperty('isShowMyPageCheckRegister')) {
        type = this._config.app_config.configValue.isShowMyPageCheckRegister
      } else {
        type = 1
      }
      return type
    },
    isShowMyPageRedbag() {
      let type = 1
      if (this._config.app_config.configValue.hasOwnProperty('isShowMyPageRedbag')) {
        type = this._config.app_config.configValue.isShowMyPageRedbag
      } else {
        type = 1
      }
      return type
    },
    myPageList() {
      let list = []
      if (this._config.app_config.configValue.hasOwnProperty('myPageItems')) {
        list = this._config.app_config.configValue.myPageItems
      } else {
        list = this.myPageItems
      }
      try {
        list.map(e => {
          if (e.key == 'record') {
            e.items.map(e2 => {
              e2.isShowOutBox = true
              if (e2.key == 'activity') {
                e2.isShowOutBox = !!this._sysConfig.act_handle_hall_url
              }
            })
          }
        })
      } catch (e) {
        console.log('活动办理没有配置跳转url时不显示盒子')
      }

      return list
    },
    isDark() {
      if (this._config.app_config.configValue.isDarkMode) {
        return true
      } else if (this._config.app_config.configValue.template) {
        if (
          this._config.app_config.configValue.template.index &&
          this._config.app_config.configValue.template.index == 'ks'
        ) {
          return true
        } else if (
          this._config.app_config.configValue.template.index &&
          this._config.app_config.configValue.template.index == 'kszl'
        ) {
          return true
        } else {
          return false
        }
      } else {
        return false
      }
    },
    K3BetContent() {
      const app_my_config = this.$store.getters['app/app_my_config']
      const k3DA = app_my_config.k3DA.name
      const k3XIAO = app_my_config.k3XIAO.name
      const k3DAN = app_my_config.k3DAN.name
      const k3SHUANG = app_my_config.k3SHUANG.name
      return [k3DA, k3XIAO, k3DAN, k3SHUANG]
    },
    k3DXDSPickerTitle() {
      return this.app_my_config.k3DXDSPickerTitle.name
    },
    vipName() {
      let re = /[^\u4E00-\u9FA5]/
      let reg = re.test(this.levelNow.levelName) ? 5 : 3
      return reg
    },
    _lotteryStyle() {
      return this._config.lotteryHall && this._config.lotteryHall.configValue.template
        ? this._config.lotteryHall.configValue.template
        : ''
    },
    _cdn() {
      return this.$store.getters['app/cdn']
    },
    _customUploadAvatorCdn() {
      return this.$store.getters['app/customUploadAvatorCdn']
    },
    _lotteryUrl() {
      return this._config.app_config.configValue.lotteryUrl
        ? `${this._cdn}/${this._config.app_config.configValue.lotteryUrl}`
        : `${this._cdn}/app/lottery_images/`
    },
    _project_name() {
      return this.$store.getters['app/project_name']
    },
    _webname() {
      return this.$store.getters['app/webname']
    },
    _config() {
      return this.$store.state.app.appConfig
    },
    _icoUrl() {
      return this._config.site_config.configValue.ico
    },
    _sysConfig() {
      return this.$store.state.sysParameter.sysParam
    },
    _app_logo() {
      return this.$store.getters['app/app_logo']
    },
    _appReady() {
      return this.$store.state.app.appReady
    },
    showBottomTab() {
      return this.$store.state.app.showBottomTab
    },
    app_my_config() {
      return this.$store.getters['app/app_my_config']
    },
    bottomTemplate() {
      try {
        return this._config.app_config.configValue.template.tabbarTemplate
      } catch (error) {
        return ''
      }
    },

    bottom_router() {
      let router = [
        {
          key: 'IndexPage',
          to: '/',
          icon: 'shouye',
          label: '首页'
        },
        {
          key: 'OpeningAccountCenter',
          to: '/OpeningAccountCenter',
          icon: 'OpeningAccountCenter',
          label: '推广赚钱'
        },
        {
          key: 'PictureWarehouse',
          to: '/PictureWarehouse',
          icon: 'liuhe',
          label: '图库'
        },
        {
          key: 'ElegameSports',
          to: '/elesports',
          icon: 'dianjing',
          label: '电竞'
        },
        {
          key: 'Sports',
          to: '/sports',
          icon: 'tiyu',
          label: '体育'
        },
        {
          key: 'Discovery',
          to: '/discovery',
          icon: 'faxian',
          label: '发现'
        },
        {
          key: 'Chess',
          to: '/chessHall',
          icon: 'qipai1',
          label: '棋牌'
        },
        {
          key: 'DsfPlatformList',
          to: '/dsfGameList',
          icon: 'qipai1',
          label: '棋牌'
        },
        {
          key: 'Fish',
          to: '/fishHall',
          icon: 'buyudaren2',
          label: '捕鱼'
        },
        {
          key: 'LotteryHall',
          to: '/lotteryhall',
          icon: 'goucai',
          label: '彩票'
        },
        {
          key: 'Elegame',
          to: '/egameHall',
          icon: 'dianzi',
          label: '电子'
        },
        {
          key: 'My',
          to: '/my',
          icon: 'wode',
          label: '我的'
        },
        {
          key: 'Preferential',
          to: '/Preferential',
          icon: 'youhuixinxi',
          label: '活动'
        },
        {
          key: 'Trend',
          to: '/lottery/trend',
          icon: 'zoushi',
          label: '走势'
        },
        {
          key: 'Openlobby',
          to: '/Openlobby',
          icon: 'Fill-copy',
          label: '开奖'
        },
        {
          key: 'forum',
          to: '/forum',
          icon: 'xiaoxizhongxin',
          label: '论坛'
        },
        {
          key: 'Kefu',
          to: '/service',
          icon: 'xingzhuang',
          label: '在线客服'
        },
        {
          key: 'IM',
          to: '/im',
          icon: 'xiaoxizhongxin',
          label: '聊天室'
        },
        {
          key: 'Realman',
          to: '/realman',
          icon: 'zhenren',
          label: '真人视讯'
        },
        {
          key: 'BetRecord',
          to: '/bettingplatform',
          icon: 'betRecord',
          label: '注单'
        },
        {
          key: 'Xuanfei',
          to: '/Xuanfei',
          icon: 'handheart',
          label: '选妃'
        },
        {
          key: 'Dating',
          to: '/Dating',
          icon: 'yuehui',
          label: '约会'
        },
        {
          key: 'GameTab',
          to: '/GameTab',
          icon: 'zonghegame',
          label: '游戏'
        },
        {
          key: 'DsfPlatformList',
          to: '/dsfGameList',
          icon: 'zonghegame',
          label: '游戏'
        },
        //forum3的菜单
        {
          key: 'home',
          to: '/',
          icon: 'home',
          label: '首页'
        },
        {
          key: 'gift',
          to: '/Preferential',
          icon: 'gift',
          label: '优惠活动'
        },
        {
          key: 'gamehall',
          to: '/GameTab',
          icon: 'gamehall',
          label: '游戏大厅'
        },
        {
          key: 'im',
          to: '/im',
          icon: 'im',
          label: '聊天室'
        },
        {
          key: 'DownloadApp',
          to: '/DownloadApp',
          icon: 'downloadApp',
          label: 'APP下载'
        },
        {
          key: 'my',
          to: '/my',
          icon: 'my',
          label: '我的'
        },
        {
          key: 'MemberActivity',
          to: '/activityRoom',
          icon: 'memberActivity',
          label: '活动大厅'
        }
      ]
      if (this.bottomTemplate == 'dfcp') {
        router = [
          {
            key: 'IndexPage',
            to: '/',
            icon: 'df-home',
            label: '首页'
          },
          {
            key: 'OpeningAccountCenter',
            to: '/OpeningAccountCenter',
            icon: 'df-OpeningAccountCenter',
            label: '推广赚钱'
          },
          {
            key: 'PictureWarehouse',
            to: '/PictureWarehouse',
            icon: 'liuhe',
            label: '图库'
          },
          {
            key: 'ElegameSports',
            to: '/elesports',
            icon: 'df-dj',
            label: '电竞'
          },
          {
            key: 'Sports',
            to: '/sports',
            icon: 'df-ty',
            label: '体育'
          },
          {
            key: 'Discovery',
            to: '/discovery',
            icon: 'df-fx',
            label: '发现'
          },
          {
            key: 'Chess',
            to: '/chessHall',
            icon: 'df-qp',
            label: '棋牌'
          },
          {
            key: 'DsfPlatformList',
            to: '/dsfGameList',
            icon: 'df-qp',
            label: '棋牌'
          },
          {
            key: 'Fish',
            to: '/fishHall',
            icon: 'df-by',
            label: '捕鱼'
          },
          {
            key: 'LotteryHall',
            to: '/lotteryhall',
            icon: 'df-gc',
            label: '彩票'
          },
          {
            key: 'Elegame',
            to: '/egameHall',
            icon: 'df-dz',
            label: '电子'
          },
          {
            key: 'My',
            to: '/my',
            icon: 'df-my',
            label: '我的'
          },
          {
            key: 'Preferential',
            to: '/Preferential',
            icon: 'df-youhuixinxi',
            label: '活动'
          },
          {
            key: 'Trend',
            to: '/lottery/trend',
            icon: 'df-zs',
            label: '走势'
          },
          {
            key: 'Openlobby',
            to: '/Openlobby',
            icon: 'df-kj',
            label: '开奖'
          },
          {
            key: 'forum',
            to: '/forum',
            icon: 'df-xiaoxizhongxin',
            label: '论坛'
          },
          {
            key: 'Kefu',
            to: '/service',
            icon: 'df-kefu',
            label: '在线客服'
          },
          {
            key: 'IM',
            to: '/im',
            icon: 'df-im',
            label: '聊天室'
          },
          {
            key: 'Realman',
            to: '/realman',
            icon: 'df-zr',
            label: '真人视讯'
          },
          {
            key: 'BetRecord',
            to: '/bettingplatform',
            icon: 'df-betRecord',
            label: '注单'
          },
          {
            key: 'GameTab',
            to: '/GameTab',
            icon: 'df-zonghegame',
            label: '游戏'
          },
          {
            key: 'DsfPlatformList',
            to: '/dsfGameList',
            icon: 'df-zonghegame',
            label: '游戏'
          },
          {
            key: 'MemberActivity',
            to: '/activityRoom',
            icon: 'df-memberActivity',
            label: '活动大厅'
          }
        ]
      }
      try {
        const bottomTabs = this.$store.state.app.appConfig.app_config.configValue.bottomTabs.value.filter(
          item => !item.isEnable || item.isEnable == '1'
        )
        let tabs = []
        bottomTabs.forEach(route => {
          let item = router.find(e => {
            if (e.key === 'IM') {
              return e.key == route.screen && route.platform != 'app' && this._sysConfig.is_open_im == '1'
            } else {
              return e.key == route.screen && route.platform != 'app'
            }
          })
          if (item) {
            tabs.push({
              ...item,
              ...route
            })
          }
        })
        return tabs
      } catch {
        console.warn('tabs 配置有误')
        return this.router
      }
    },
    lotteryDropMenu() {
      const lotteryDropMenu = [
        {
          label: this.app_my_config.bettingplatform.name,
          type: 'link',
          url: '/lotteryorderhistory',
          navigate: '',
          icon: 'touzhujilu'
        },
        {
          label: '开奖历史',
          type: 'drawrecords',
          icon: 'kaijianglishi'
        },
        {
          label: '走势图表',
          type: 'trend',
          icon: 'zoushitubiao'
        },
        {
          label: '路子图',
          type: 'luzitu',
          icon: 'luzitu'
        },
        {
          label: '玩法说明',
          type: 'guide',
          icon: 'touzhujilu'
        }
      ]

      return this.$store.state.app.appConfig.app_config.configValue.lotteryDropMenu || lotteryDropMenu
    },
    lotteryOrderStatus() {
      let arr = [
        `未${this.app_my_config.drawLottery2.name}`,
        `已${this.app_my_config.winPrize.name}`,
        '手工撤单',
        '系统撤单',
        `未${this.app_my_config.winPrize.name}`,
        '下单失败',
        '和局撤单',
        '系统撤销',
        `${this.app_my_config.orderRollBack.name}`
      ]
      return arr
    },
    copyRightEndYear() {
      let defaultYear = new Date().getFullYear()
      try {
        return this._config.footer_text && this._config.footer_text.configValue.copyRightEndYear
          ? this._config.footer_text.configValue.copyRightEndYear
          : defaultYear
      } catch {
        return defaultYear
      }
    },
    copyRightStartYear() {
      let defaultYear = '2008'
      try {
        return this._config.footer_text && this._config.footer_text.configValue.copyRightStartYear
          ? this._config.footer_text.configValue.copyRightStartYear
          : defaultYear
      } catch {
        return defaultYear
      }
    },

    isShowPreferentialListTime() {
      let flag = 1
      try {
        flag =
          this._config.page_preferential.configValue.isShowPreferentialListTimeApp ||
          this._config.page_preferential.configValue.isShowPreferentialListTime
        flag = flag === undefined ? 1 : flag
      } catch (e) {
        flag = 1
      }
      return Boolean(flag)
    },
    isShowMulcontent() {
      let flag = '1'
      try {
        flag =
          this._config.page_preferential.configValue.isShowMulcontentApp ||
          this._config.page_preferential.configValue.isShowMulcontent
        flag = flag === undefined ? '1' : flag
      } catch (e) {
        flag = '1'
      }

      return flag
    },
    isShowStatus() {
      let flag = 1
      try {
        flag =
          this._config.page_preferential.configValue.isShowStatusApp ||
          this._config.page_preferential.configValue.isShowStatus
        flag = flag === undefined ? 1 : flag
      } catch (e) {
        flag = 1
      }

      return flag
    },

    isShowRpRateInfo() {
      let isShowRpRateInfo = '1'
      try {
        isShowRpRateInfo = this._config.common_config.configValue.isShowRpRateInfo
        isShowRpRateInfo = isShowRpRateInfo == undefined ? '1' : isShowRpRateInfo
      } catch { }
      return isShowRpRateInfo
    },
    fromLotteryTo() {
      if (this._config.app_config.configValue.hasOwnProperty('fromLotteryTo')) {
        return this._config.app_config.configValue.fromLotteryTo
          ? this._config.app_config.configValue.fromLotteryTo
          : false
      }
    }
  },
  methods: {
    toHome() {
      if (this.fromLotteryTo) {
        this.$router.push('/')
      } else {
        this.$router.back()
      }
    },
    isEnable(key) {
      let stateList = []
      let state
      let Enableitem = {}
      if (
        this._config.app_config.configValue.hasOwnProperty('template') &&
        this._config.app_config.configValue.hasOwnProperty('my') &&
        this._config.app_config.configValue.template.my == 'fh31'
      ) {
        this.myPageList.forEach(item => {
          if (item.key == 'proxy' || item.key == 'finance') {
            item.isEnable = 0
          }
        })
      }
      this.myPageList.forEach(item => {
        if (item.isEnable && item.key == key) {
          item.items.forEach(items => {
            if (items.isEnable) {
              stateList.push(1)
            } else {
              stateList.push(0)
            }
          })
        }
      })

      let type = stateList.indexOf(1)
      if (type == -1) {
        state = 0
        this.myPageList.forEach(item => {
          if (item.isEnable && item.key == key) {
            item.isEnable = 0
          }
        })
      } else {
        state = 1
      }
      this.myPageList.forEach(items => {
        if (items.key == 'proxy' && key == 'proxy') {
          Enableitem = items
        }
      })
      if (key == 'proxy' && this.userInfo.memberType != 2) {
        return '0'
      }
      return state
    },
    setIsEnable(key) {
      let item, isEnable
      this.myPageList.forEach(items => {
        if (items.key == key) {
          item = items
        } else {
          items.items &&
            items.items.forEach(itemx => {
              if (itemx.key == 'transfer' && key == 'transfer') {
                let off = this.gameType.some(ele => {
                  return ele.code == 'realman' || ele.code == 'chess' || ele.code == 'elegame' || ele.code == 'sports'
                })
                itemx.isEnable = off == true ? 1 : 0
              }
              if (itemx.key == key) {
                item = itemx
              }
            })
        }
      })
      if (item) {
        switch (item.key) {
          case 'balanceIncome':
            isEnable = this._sysConfig.is_open_balance_income
            break
          case 'yeb':
            isEnable = this._sysConfig.is_open_yeb
            break
          case 'redbag':
            isEnable = this.is_open_red_bag
            break
          case 'checkRegister':
            isEnable = this.is_open_sign
            break
          case 'openingAccountCenter':
            isEnable =
              (this._sysConfig.is_open_porxy_create_user === '1' ||
                this._sysConfig.is_account_as_promote_code === '0') &&
                item.isEnable
                ? 1
                : 0
            break
          case 'transfertomember':
            isEnable = this._sysConfig.is_open_transfer
            break
          default:
            isEnable = item.isEnable
            break
        }
      }

      return isEnable
    },
    // first
    first() {
      let arr = this.myPageList.filter(item => {
        if (item.isEnable == 1) {
          return item
        }
      })
      return arr[0].key
    },
    // 省略过长的会员等级
    strLenght(str) {
      let strLenght = str.replace(/[^\x00-\xff]/g, '**').length
      console.log(str)
      let reg = new RegExp('[\\u4E00-\\u9FFF]+', 'g')
      if (reg.test(str)) {
        if (strLenght > 6) {
          str = str.substring(0, 3) + '...'
        }
      } else {
        if (strLenght > 6) {
          str = str.substring(0, 5) + '...'
        }
      }
      return str
    },
    routeBack({ numb = -1 }) {
      const currHref = window.location.href
      if (window.history.length <= 1) {
        this.$router.push({ path: '/' })
      } else {
        this.$router.go(numb)
        setTimeout(() => {
          if (window.location.href == currHref) {
            if (window.android) {
              window.android.goBack()
            }
            this.$router.push({ path: '/' })
          }
        }, 100)
      }
    }
  }
}
</script>
